export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7055.82343f2e.jpg";